import React from 'react';
import "./PlanType.css";

const PlanType = ({handleClick}) => {
    return ( 
        <div className="react-nav-container">
            <ul className="nav nav-pills flex-column flex-sm-row">
                <li className="nav-item" onClick={() => handleClick("Standard")}>
                    <a href="#standard" className="nav-link" data-toggle="tab"><span>Standard</span></a>
                </li>
                <li className="nav-item" onClick={() => handleClick("Enterprise")}>
                    <a href="#enterprise" className="nav-link active" data-toggle="tab"><span>Enterprise</span></a>
                </li>
                <li className="nav-item" onClick={() => handleClick("Mission Critical")}>
                    <a href="#mission-critical" className="nav-link" data-toggle="tab"><span>Mission Critical</span></a>
                </li>
            </ul>
        </div>
     );
}
 
export default PlanType;